// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-dialog-viewport {
  position: absolute;
  inset: 0;
  z-index: 120;
  container-type: inline-size;
  pointer-events: none;
}

body > .map-dialog-viewport {
  position: fixed;
}

.map-dialog-scrim {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: transparent;
  pointer-events: none;
  box-sizing: border-box;
}

body > .map-dialog-scrim {
  position: fixed;
}

.map-dialog-panel {
  --map-dialog-accent: #ef4444;
  position: relative;
  width: min(100%, 480px);
  min-width: min(320px, 100%);
  padding: 24px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.045);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 12px;
  backdrop-filter: blur(18px) saturate(1.2);
  -webkit-backdrop-filter: blur(18px) saturate(1.2);
  color: rgba(248, 250, 252, 0.94);
  pointer-events: auto;
  overflow: hidden;
  animation: map-dialog-pop-in 220ms cubic-bezier(0.2, 0.9, 0.3, 1) forwards;
}

.map-dialog-panel::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(251, 191, 36, 0.95) 18%,
    rgba(251, 191, 36, 0.95) 82%,
    transparent 100%
  );
  pointer-events: none;
}

@keyframes map-dialog-pop-in {
  from {
    opacity: 0;
    transform: scale(0.97) translateY(6px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.map-dialog-kicker {
  margin: 0 0 10px;
  color: var(--map-dialog-accent);
  font-size: 10px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: 0.22em;
  text-transform: uppercase;
}

.map-dialog-title {
  margin: 0;
  max-width: 38ch;
  color: rgba(248, 250, 252, 0.94);
  font-size: 16px;
  font-weight: 700;
  line-height: 1.42;
  letter-spacing: 0;
}

.map-dialog-body {
  margin-top: 12px;
  max-width: 38ch;
  color: rgba(248, 250, 252, 0.62);
  font-size: 13px;
  font-weight: 400;
  line-height: 1.45;
  letter-spacing: 0;
}

.map-dialog-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
}

.map-dialog-button {
  min-height: 34px;
  min-width: 72px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid transparent;
  font-family: inherit;
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: 0.03em;
  white-space: nowrap;
  cursor: pointer;
  transition: background 150ms ease, border-color 150ms ease, color 150ms ease, transform 150ms ease, opacity 150ms ease;
}

.map-dialog-button--ghost {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.10);
  color: rgba(255, 255, 255, 0.60);
}

.map-dialog-button--ghost:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.20);
  color: rgba(248, 250, 252, 0.92);
}

.map-dialog-button--primary {
  background: rgba(239, 68, 68, 0.15);
  background: color-mix(in srgb, var(--map-dialog-accent) 16%, transparent);
  border-color: rgba(239, 68, 68, 0.36);
  border-color: color-mix(in srgb, var(--map-dialog-accent) 36%, transparent);
  color: var(--map-dialog-accent);
}

.map-dialog-button--primary:hover:not(:disabled) {
  background: rgba(239, 68, 68, 0.22);
  background: color-mix(in srgb, var(--map-dialog-accent) 24%, transparent);
  border-color: rgba(239, 68, 68, 0.52);
  border-color: color-mix(in srgb, var(--map-dialog-accent) 52%, transparent);
  transform: translateY(-1px);
}

.map-dialog-button:disabled {
  opacity: 0.46;
  cursor: not-allowed;
  transform: none;
}

.map-dialog-spinner {
  width: 12px;
  height: 12px;
  border-radius: 999px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  animation: map-dialog-spin 700ms linear infinite;
}

@keyframes map-dialog-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 1800px) {
  .map-dialog-scrim {
    padding: 16px;
  }

  .map-dialog-panel {
    width: min(100%, 440px);
    min-width: min(320px, 100%);
    padding: 20px;
  }

  .map-dialog-actions {
    flex-wrap: wrap;
  }
}

@container (max-width: 1800px) {
  .map-dialog-scrim {
    padding: clamp(16px, 1.1cqi, 20px);
  }

  .map-dialog-panel {
    padding: clamp(18px, 1.2cqi, 20px);
  }

  .map-dialog-kicker {
    margin-bottom: clamp(8px, 0.6cqi, 10px);
    font-size: clamp(9px, 0.58cqi, 10px);
  }

  .map-dialog-title {
    max-width: min(36ch, 100%);
    font-size: clamp(14px, 0.9cqi, 16px);
  }

  .map-dialog-body {
    margin-top: clamp(10px, 0.72cqi, 12px);
    max-width: min(36ch, 100%);
    font-size: clamp(12px, 0.74cqi, 13px);
  }

  .map-dialog-actions {
    gap: clamp(8px, 0.72cqi, 12px);
    margin-top: clamp(18px, 1.35cqi, 24px);
  }

  .map-dialog-button {
    min-height: 32px;
    min-width: 68px;
    padding: 8px clamp(12px, 0.9cqi, 16px);
    font-size: 11px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .map-dialog-panel,
  .map-dialog-spinner {
    animation: none;
  }
}

.map-dialog-preview {
  min-height: var(--admin-tool-canvas-height, calc(100vh - 96px));
  padding: 24px;
  box-sizing: border-box;
  color: rgba(248, 250, 252, 0.92);
  background: #08080a;
}

.map-dialog-preview__header {
  max-width: 1120px;
  margin: 0 auto 18px;
}

.map-dialog-preview__header h1 {
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: 0;
}

.map-dialog-preview__header p {
  margin: 0;
  max-width: 118ch;
  color: rgba(248, 250, 252, 0.68);
  font-size: 13px;
  line-height: 1.45;
  letter-spacing: 0;
}

.map-dialog-preview__triggers {
  max-width: 1120px;
  margin: 0 auto 18px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 12px;
}

.map-dialog-preview__trigger {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-start;
}

.map-dialog-preview__trigger button {
  width: 100%;
  min-height: 38px;
  padding: 9px 12px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.06);
  color: rgba(248, 250, 252, 0.92);
  font-family: inherit;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: 0;
  text-align: left;
  cursor: pointer;
}

.map-dialog-preview__trigger button:hover {
  background: rgba(255, 255, 255, 0.10);
  border-color: rgba(251, 191, 36, 0.40);
}

.map-dialog-preview__caption {
  margin: 0;
  color: rgba(248, 250, 252, 0.56);
  font-size: 11px;
  line-height: 1.35;
  letter-spacing: 0;
}

.map-dialog-preview__map-label {
  position: absolute;
  inset: 18px auto auto 18px;
  color: rgba(248, 250, 252, 0.42);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
}
`, "",{"version":3,"sources":["webpack://./src/components/MapDialog/MapDialog.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,2CAA2C;EAC3C,mBAAmB;EACnB,yCAAyC;EACzC,iDAAiD;EACjD,gCAAgC;EAChC,oBAAoB;EACpB,gBAAgB;EAChB,0EAA0E;AAC5E;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;;;;GAMC;EACD,oBAAoB;AACtB;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,sHAAsH;AACxH;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,yEAAyE;EACzE,qCAAqC;EACrC,2EAA2E;EAC3E,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,yEAAyE;EACzE,qCAAqC;EACrC,2EAA2E;EAC3E,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,8BAA8B;EAC9B,+BAA+B;EAC/B,gDAAgD;AAClD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,uCAAuC;IACvC,oCAAoC;EACtC;;EAEA;IACE,0BAA0B;IAC1B,oCAAoC;EACtC;;EAEA;IACE,sCAAsC;IACtC,0BAA0B;IAC1B,qCAAqC;EACvC;;EAEA;IACE,8BAA8B;IAC9B,sCAAsC;EACxC;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,+DAA+D;EAC/D,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB","sourcesContent":[".map-dialog-viewport {\n  position: absolute;\n  inset: 0;\n  z-index: 120;\n  container-type: inline-size;\n  pointer-events: none;\n}\n\nbody > .map-dialog-viewport {\n  position: fixed;\n}\n\n.map-dialog-scrim {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: transparent;\n  pointer-events: none;\n  box-sizing: border-box;\n}\n\nbody > .map-dialog-scrim {\n  position: fixed;\n}\n\n.map-dialog-panel {\n  --map-dialog-accent: #ef4444;\n  position: relative;\n  width: min(100%, 480px);\n  min-width: min(320px, 100%);\n  padding: 24px;\n  box-sizing: border-box;\n  background: rgba(255, 255, 255, 0.045);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 12px;\n  backdrop-filter: blur(18px) saturate(1.2);\n  -webkit-backdrop-filter: blur(18px) saturate(1.2);\n  color: rgba(248, 250, 252, 0.94);\n  pointer-events: auto;\n  overflow: hidden;\n  animation: map-dialog-pop-in 220ms cubic-bezier(0.2, 0.9, 0.3, 1) forwards;\n}\n\n.map-dialog-panel::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: linear-gradient(\n    90deg,\n    transparent 0%,\n    rgba(251, 191, 36, 0.95) 18%,\n    rgba(251, 191, 36, 0.95) 82%,\n    transparent 100%\n  );\n  pointer-events: none;\n}\n\n@keyframes map-dialog-pop-in {\n  from {\n    opacity: 0;\n    transform: scale(0.97) translateY(6px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.map-dialog-kicker {\n  margin: 0 0 10px;\n  color: var(--map-dialog-accent);\n  font-size: 10px;\n  font-weight: 800;\n  line-height: 1.2;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n}\n\n.map-dialog-title {\n  margin: 0;\n  max-width: 38ch;\n  color: rgba(248, 250, 252, 0.94);\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.42;\n  letter-spacing: 0;\n}\n\n.map-dialog-body {\n  margin-top: 12px;\n  max-width: 38ch;\n  color: rgba(248, 250, 252, 0.62);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1.45;\n  letter-spacing: 0;\n}\n\n.map-dialog-actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.map-dialog-button {\n  min-height: 34px;\n  min-width: 72px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 1;\n  letter-spacing: 0.03em;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background 150ms ease, border-color 150ms ease, color 150ms ease, transform 150ms ease, opacity 150ms ease;\n}\n\n.map-dialog-button--ghost {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.10);\n  color: rgba(255, 255, 255, 0.60);\n}\n\n.map-dialog-button--ghost:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.20);\n  color: rgba(248, 250, 252, 0.92);\n}\n\n.map-dialog-button--primary {\n  background: rgba(239, 68, 68, 0.15);\n  background: color-mix(in srgb, var(--map-dialog-accent) 16%, transparent);\n  border-color: rgba(239, 68, 68, 0.36);\n  border-color: color-mix(in srgb, var(--map-dialog-accent) 36%, transparent);\n  color: var(--map-dialog-accent);\n}\n\n.map-dialog-button--primary:hover:not(:disabled) {\n  background: rgba(239, 68, 68, 0.22);\n  background: color-mix(in srgb, var(--map-dialog-accent) 24%, transparent);\n  border-color: rgba(239, 68, 68, 0.52);\n  border-color: color-mix(in srgb, var(--map-dialog-accent) 52%, transparent);\n  transform: translateY(-1px);\n}\n\n.map-dialog-button:disabled {\n  opacity: 0.46;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.map-dialog-spinner {\n  width: 12px;\n  height: 12px;\n  border-radius: 999px;\n  border: 2px solid currentColor;\n  border-right-color: transparent;\n  animation: map-dialog-spin 700ms linear infinite;\n}\n\n@keyframes map-dialog-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 1800px) {\n  .map-dialog-scrim {\n    padding: 16px;\n  }\n\n  .map-dialog-panel {\n    width: min(100%, 440px);\n    min-width: min(320px, 100%);\n    padding: 20px;\n  }\n\n  .map-dialog-actions {\n    flex-wrap: wrap;\n  }\n}\n\n@container (max-width: 1800px) {\n  .map-dialog-scrim {\n    padding: clamp(16px, 1.1cqi, 20px);\n  }\n\n  .map-dialog-panel {\n    padding: clamp(18px, 1.2cqi, 20px);\n  }\n\n  .map-dialog-kicker {\n    margin-bottom: clamp(8px, 0.6cqi, 10px);\n    font-size: clamp(9px, 0.58cqi, 10px);\n  }\n\n  .map-dialog-title {\n    max-width: min(36ch, 100%);\n    font-size: clamp(14px, 0.9cqi, 16px);\n  }\n\n  .map-dialog-body {\n    margin-top: clamp(10px, 0.72cqi, 12px);\n    max-width: min(36ch, 100%);\n    font-size: clamp(12px, 0.74cqi, 13px);\n  }\n\n  .map-dialog-actions {\n    gap: clamp(8px, 0.72cqi, 12px);\n    margin-top: clamp(18px, 1.35cqi, 24px);\n  }\n\n  .map-dialog-button {\n    min-height: 32px;\n    min-width: 68px;\n    padding: 8px clamp(12px, 0.9cqi, 16px);\n    font-size: 11px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .map-dialog-panel,\n  .map-dialog-spinner {\n    animation: none;\n  }\n}\n\n.map-dialog-preview {\n  min-height: var(--admin-tool-canvas-height, calc(100vh - 96px));\n  padding: 24px;\n  box-sizing: border-box;\n  color: rgba(248, 250, 252, 0.92);\n  background: #08080a;\n}\n\n.map-dialog-preview__header {\n  max-width: 1120px;\n  margin: 0 auto 18px;\n}\n\n.map-dialog-preview__header h1 {\n  margin: 0 0 8px;\n  font-size: 20px;\n  font-weight: 800;\n  line-height: 1.2;\n  letter-spacing: 0;\n}\n\n.map-dialog-preview__header p {\n  margin: 0;\n  max-width: 118ch;\n  color: rgba(248, 250, 252, 0.68);\n  font-size: 13px;\n  line-height: 1.45;\n  letter-spacing: 0;\n}\n\n.map-dialog-preview__triggers {\n  max-width: 1120px;\n  margin: 0 auto 18px;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 12px;\n}\n\n.map-dialog-preview__trigger {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  align-items: flex-start;\n}\n\n.map-dialog-preview__trigger button {\n  width: 100%;\n  min-height: 38px;\n  padding: 9px 12px;\n  border-radius: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.06);\n  color: rgba(248, 250, 252, 0.92);\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 1.25;\n  letter-spacing: 0;\n  text-align: left;\n  cursor: pointer;\n}\n\n.map-dialog-preview__trigger button:hover {\n  background: rgba(255, 255, 255, 0.10);\n  border-color: rgba(251, 191, 36, 0.40);\n}\n\n.map-dialog-preview__caption {\n  margin: 0;\n  color: rgba(248, 250, 252, 0.56);\n  font-size: 11px;\n  line-height: 1.35;\n  letter-spacing: 0;\n}\n\n.map-dialog-preview__map-label {\n  position: absolute;\n  inset: 18px auto auto 18px;\n  color: rgba(248, 250, 252, 0.42);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
